/** @jsx jsx */
import { jsx } from 'theme-ui';
import { useContext } from 'react';
import PropTypes from 'prop-types';
import { MdClose } from 'react-icons/md';
import { SiteContext } from '../../contexts/site';

const Burger = ({ size }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="currentcolor"
    viewBox="0 0 24 24"
    sx={{
      display: 'block',
      margin: 0,
    }}
  >
    <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
  </svg>
);

Burger.propTypes = {
  size: PropTypes.string,
};

Burger.defaultProps = {
  size: '1em',
};

const MenuButton = (props) => {
  const { primaryNavOpen, setPrimaryNavOpen } = useContext(SiteContext);
  return (
    <button
      title="Toggle Menu"
      type="button"
      {...props}
      sx={{
        bg: primaryNavOpen ? 'PrimaryDarkBlue' : 'transparent',
        px: '2rem',
        height: '100%',
        border: 0,
        appearance: 'none',
        ':focus': {
          outline: '2px solid',
        },
        display: ['block', null, 'none'],
        color: primaryNavOpen ? 'white' : null,
        cursor: 'pointer',
      }}
    >
      {primaryNavOpen ? <MdClose size="24px" /> : <Burger size="24px" />}
    </button>
  );
};

export default MenuButton;
